export function getMultipleRandom(arr, num) {
    const shuffled = [...arr].sort(() => 0.5 - Math.random());

    return shuffled.slice(0, num);
}

export function getRandomOtherThan(other, min, max) {
    let number = Math.floor(Math.random() * (max - min + 1)) + min;
    if (other === null) {
        return number
    }

    if (max <= min) {
        return max
    }

    if (number === other) {
        number = getRandomOtherThan(other, min, max)
    }
    return number
}